import { APP } from "@constants/app.constants";
const { STATUS } = APP;

export const getSmsTemplateFormInputs = (initialValues) => [
  {
    type: "TEXT",
    label: "Name",
    id: "name",
    name: "name",
    value: initialValues?.name || "",
    placeholder: "Enter the name",
    validations: [
      {
        type: "REQUIRED",
        message: "Name is required !",
      },
    ],
  },
  {
    type: "TEXT",
    label: "Content",
    id: "content",
    name: "content",
    value: initialValues?.content || "",
    placeholder: "Enter the Content",
    validations: [],
  },

  {
    type: "SELECT",
    label: "Status",
    id: "status",
    name: "status",
    options: STATUS,
    value: initialValues?.status || 1,
    placeholder: "Select Status",
    validations: [
      {
        type: "REQUIRED",
        message: "Status is required !",
      },
    ],
  },
];
